import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Wrench, X } from "lucide-react";

/**
 * Persistent floating "Zgłoś usterkę" button (bottom-right).
 * Hidden on /zglos-usterke and /adm1n pages.
 * Auto-hides after dismiss for the current browser session.
 */
export default function ReportFloatingButton() {
    const navigate = useNavigate();
    const location = useLocation();
    const [hidden, setHidden] = useState(() => {
        try { return sessionStorage.getItem("rfb-hidden") === "1"; } catch { return false; }
    });
    const [expanded, setExpanded] = useState(false);

    // Show "label" briefly when first appearing
    useEffect(() => {
        const t = setTimeout(() => setExpanded(true), 800);
        const t2 = setTimeout(() => setExpanded(false), 4500);
        return () => { clearTimeout(t); clearTimeout(t2); };
    }, []);

    const shouldHide = hidden
        || location.pathname.startsWith("/zglos-usterke")
        || location.pathname.startsWith("/adm1n");
    if (shouldHide) return null;

    const dismiss = (e) => {
        e.stopPropagation();
        try { sessionStorage.setItem("rfb-hidden", "1"); } catch (_) { /* noop */ }
        setHidden(true);
    };

    return (
        <button
            onClick={() => navigate("/zglos-usterke")}
            onMouseEnter={() => setExpanded(true)}
            onMouseLeave={() => setExpanded(false)}
            data-testid="report-floating-button"
            aria-label="Zgłoś usterkę"
            className="fixed bottom-5 right-5 md:bottom-7 md:right-7 z-40 flex items-center gap-2 bg-[#D4A537] hover:bg-[#E5B649] text-[#092E22] font-semibold rounded-full shadow-2xl ring-4 ring-[#D4A537]/30 hover:ring-[#D4A537]/50 transition-all hover:scale-105 active:scale-95"
            style={{ paddingLeft: expanded ? 20 : 16, paddingRight: expanded ? 20 : 16, paddingTop: 14, paddingBottom: 14 }}
        >
            <Wrench size={20} strokeWidth={2.5} />
            <span
                className="whitespace-nowrap overflow-hidden transition-all duration-300 text-sm"
                style={{
                    maxWidth: expanded ? 180 : 0,
                    opacity: expanded ? 1 : 0,
                    marginLeft: expanded ? 0 : -4,
                }}
            >
                Zgłoś usterkę
            </span>
            <span
                onClick={dismiss}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => { if (e.key === "Enter") dismiss(e); }}
                className="hidden md:flex items-center justify-center w-5 h-5 rounded-full bg-[#092E22]/15 hover:bg-[#092E22]/30 cursor-pointer ml-1"
                aria-label="Ukryj przycisk"
                data-testid="report-floating-button-dismiss"
            >
                <X size={11} className="text-[#092E22]" />
            </span>
        </button>
    );
}
